import { createSlice } from '@reduxjs/toolkit';

const dietSlice = createSlice({
    name: 'diet',
    initialState: {
        loading: false,
        templates: [],
        diets: [],
        allPatientDiets: [],
        currentDiet: null,
        error: null,
        isDietCreated: false,
        isDietUpdated: false,
        isDietDeleted: false,
        isTemplateCreated: false,
        isTemplateUpdated: false,
        isTemplateDeleted: false,
    },
    reducers: {
        dietRequest(state) {
            state.loading = true;
            state.error = null;
        },
        dietFail(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        clearDietError(state) {
            state.error = null;
        },

        // Master templates
        templatesSuccess(state, action) {
            state.loading = false;
            state.templates = action.payload || [];
        },
        templateCreatedSuccess(state, action) {
            state.loading = false;
            state.templates = [action.payload, ...state.templates];
            state.isTemplateCreated = true;
        },
        templateDeletedSuccess(state, action) {
            state.loading = false;
            const targetId = String(action.payload);
            state.templates = state.templates.filter(
                t => String(t._id || t.id) !== targetId
            );
            state.isTemplateDeleted = true;
        },
        templateUpdatedSuccess(state, action) {
            state.loading = false;
            const targetId = action.payload._id || action.payload.id;
            state.templates = state.templates.map(t =>
                String(t._id || t.id) === String(targetId) ? action.payload : t
            );
            state.isTemplateUpdated = true;
        },
        clearTemplateCreated(state) {
            state.isTemplateCreated = false;
        },
        clearTemplateUpdated(state) {
            state.isTemplateUpdated = false;
        },
        clearTemplateDeleted(state) {
            state.isTemplateDeleted = false;
        },

        // Patient diets
        allPatientDietsSuccess(state, action) {
            state.loading = false;
            state.allPatientDiets = action.payload || [];
        },
        patientDietsSuccess(state, action) {
            state.loading = false;
            state.diets = action.payload || [];
        },
        singleDietSuccess(state, action) {
            state.loading = false;
            state.currentDiet = action.payload;
        },
        dietCreatedSuccess(state, action) {
            state.loading = false;
            state.diets = [action.payload, ...state.diets];
            state.isDietCreated = true;
        },
        dietUpdatedSuccess(state, action) {
            state.loading = false;
            const targetId = action.payload._id || action.payload.id;
            state.diets = state.diets.map(d =>
                String(d._id || d.id) === String(targetId) ? action.payload : d
            );
            state.isDietUpdated = true;
        },
        dietDeletedSuccess(state, action) {
            state.loading = false;
            const targetId = String(action.payload);
            state.diets = state.diets.filter(
                d => String(d._id || d.id) !== targetId
            );
            state.allPatientDiets = state.allPatientDiets.filter(
                d => String(d._id || d.id) !== targetId
            );
            if (state.currentDiet && String(state.currentDiet._id || state.currentDiet.id) === targetId) {
                state.currentDiet = null;
            }
            state.isDietDeleted = true;
        },
        clearDietCreated(state) {
            state.isDietCreated = false;
        },
        clearDietUpdated(state) {
            state.isDietUpdated = false;
        },
        clearDietDeleted(state) {
            state.isDietDeleted = false;
        }
    }
});

const { actions, reducer } = dietSlice;

export const {
    dietRequest,
    dietFail,
    clearDietError,
    templatesSuccess,
    templateCreatedSuccess,
    templateUpdatedSuccess,
    templateDeletedSuccess,
    clearTemplateCreated,
    clearTemplateUpdated,
    clearTemplateDeleted,
    allPatientDietsSuccess,
    patientDietsSuccess,
    singleDietSuccess,
    dietCreatedSuccess,
    dietUpdatedSuccess,
    dietDeletedSuccess,
    clearDietCreated,
    clearDietUpdated,
    clearDietDeleted
} = actions;

export default reducer;

